export default __webpack_public_path__ + "static/media/information--overtaking-allowed-heavy-good-vehicles--g1.39e05fa4.png";